import styled from 'styled-components';

interface IStyleProps {
    hidden: boolean
};

export default styled.li`
    display: ${(props: IStyleProps) => props.hidden ? "hidden" : "block"};
    padding: 6px 4px;
    font-size: 1.1rem;
    &:nth-child(even) {
        background: #003087;
    }
    &.alternate:nth-child(even) {
        background: #0072ce;
    }
`;



// WEBPACK FOOTER //
// ./src/SharedComponents/QuestionContainer.tsx